import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { SelectOptionsModel } from 'src/app/shared/models/shared.model';
import { GlobalServices } from 'src/app/shared/services/global.services';
import { RestfullServices } from 'src/app/shared/services/restfull.services';
import { TaskManagerCreateComponent } from '../task-manager-create/task-manager-create.component';
import { SnackBarComponent } from 'src/app/shared/components/snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ImageViewerComponent } from '../image-viewer/image-viewer.component';

@Component({
  selector: 'app-task-manager-detail',
  templateUrl: './task-manager-detail.component.html',
  styleUrls: ['./task-manager-detail.component.scss']
})
export class TaskManagerDetailComponent implements OnInit {
  taskId: any;
  uploadResults: any;
  statusOptions: any;
  createdBy: string = "";
  // public statusOptions: SelectOptionsModel[] = [
  //   {
  //     label: "Open",
  //     value: "open",
  //   },
  //   {
  //     label: "Completed",
  //     value: "completed",
  //   },
  //   {
  //     label: "Cancel Request",
  //     value: "cancelled",
  //   },
  // ];
  public orderDetailsForm = new UntypedFormGroup({
    taskStatus: new UntypedFormControl(),
    createdBy: new UntypedFormControl(),
  });
  taskDetail: any = {
    shortDescription: ''
  };
  public tmProHotelId: number;

  isEdit = false;
  originalText = '';

  taskComments: any = [];
  editCommentId: number | null = null;
  editText: string = '';

  constructor(public globalService: GlobalServices, public router: Router, public activatedRoute: ActivatedRoute, public restfullService: RestfullServices, public cdr: ChangeDetectorRef, private dialog: MatDialog, private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.tmProHotelId = +localStorage.getItem('selectedTmProHotelId');
    this.taskId = +this.activatedRoute.snapshot.queryParams.id;
    if (this.activatedRoute.snapshot.queryParams.id) {
      this.router.navigate(["pages/tasks/task-manager-detail"], {
        queryParams: {
          id: this.activatedRoute.snapshot.queryParams.id,
        },
      });
    }
    this.globalService.headerData$.next({
      headerTitle: 'Tasks',
      showBackButton: true,
      info1: '',
      info2: '',
      navigationPage: '/pages/tasks'
    });
    //this.taskDetail = { referenceNo: 123667, taskStatus: "open", dueDate: "09/09/2025", createdBy: "", dateTimeCreated: "", responsiblePerson: "Micheal Smith", department: "Electrical", priority: "High", escalated: "Unescalated" };
    this.setHeaderData();
    //Fetch task detail By id
    if (this.taskId) {
      // this.restfullService.getTaskByTaskId(+taskId).subscribe((response) => {
      //   debugger
      //   this.restfullService.getTaskStatus
      //   this.taskDetail = response;
      // }, (err) => {
      //   this.globalService.showAlert(this.globalService.errorMsg);
      // })
      this.getCreatedBy();
      this.getTaskDetailsById(this.taskId);
      this.getTaskImages();
      this.getTaskComments();
    }
  }
  showImageModal = false;
  selectedImage = '';
  selectedImageName = '';

  getCreatedBy() {
    this.restfullService.getCreatedByTaskId(this.taskId).subscribe((response) => {
      this.createdBy = response.name;
    })
  }
  openImage(image: string, name: string): void {
    this.dialog.open(ImageViewerComponent, {
      data: {
        image: image,
        name: name
      },
      panelClass: 'image-viewer-dialog',
      backdropClass: 'image-viewer-backdrop'
    });
  }

  closeImage(): void {
    this.showImageModal = false;
    this.selectedImage = '';
    this.selectedImageName = '';
  }
  getTaskComments() {
    this.restfullService.getTaskComments(this.taskId).subscribe({
      next: (response) => {
        this.taskComments = response;
      },
      error: (err) => {
        console.error(err);
      }
    })
  }
  getTaskImages() {
    this.globalService.showLoader$.next(true);
    this.restfullService.getImage(+this.tmProHotelId, +this.taskId).subscribe({
      next: (res) => {
        this.uploadResults = res;
        this.globalService.showLoader$.next(false);
      },
      error: (err) => {
        console.error(err);
        this.globalService.showLoader$.next(false);
      }
    });
  }
  getTaskDetailsById(taskId: number) {
    forkJoin({
      task: this.restfullService.getTaskByTaskId(+taskId),
      departments: this.restfullService.getTaskDepartments(this.tmProHotelId),
      statuses: this.restfullService.getTaskStatus(),
      users: this.restfullService.getTaskAllResponsiblePerson(),
      priority: this.restfullService.getTaskPriority()
    }).subscribe({
      next: ({ task, departments, statuses, users, priority }) => {
        // Create maps for quick lookup
        const departmentMap = new Map(departments.map(d => [d.id, d.text]));
        const statusMap = new Map(statuses.map(s => [s.id, s.text]));
        const userMap = new Map(users.map(u => [u.userId, `${u.firstName}, ${u.lastName}`]));
        const priorityMap = new Map(priority.map(p => [p.id, p.text]));

        this.statusOptions = statuses;
        // Map task with additional info
        this.taskDetail = {
          ...task,
          departmentName: departmentMap.get(task.tmProDepartmentId),
          statusName: statusMap.get(task.tmProStatusId),
          responsiblePersonName: userMap.get(task.responsiblePerson),
          createdBy: this.createdBy == "" ? localStorage.getItem('email') : this.createdBy,
          priority: priorityMap.get(task.tmProPriorityId),
          createdFormatted: this.formatDate(task.created),
          closedFormatted: this.formatDate(task.closed),
          toBeDoneByFormatted: this.formatDate(task.toBeDoneBy),

        };
      },
      error: (err) => {
        this.globalService.showAlert(this.globalService.errorMsg);
      }
    });
  }
  getvalueEscalate(status) {
    return status == true ? "Escalated" : "Unescalated";
  }
  changeStatus(item) {
    //Call update Api when status is changed
    let payload = {
      id: this.taskId,
      hotelId: this.tmProHotelId,
      tmProStatusId: item.id,
      categoryId: 5,
      tmProDepartmentId: this.taskDetail?.tmProDepartmentId,
      tmProTeamId: this.taskDetail?.tmProTeamId,
      created: this.taskDetail?.created,
      closed: this.taskDetail?.closed,
      taskOwner: this.taskDetail?.taskOwner,//"61bcc4e5-3f87-4d89-885b-5e49fdeed477",
      isInternal: true,
      taskName: this.taskDetail?.taskName,
      description: this.taskDetail?.description,
      //shortDescription: this.originalText,
      responsiblePerson: this.taskDetail?.responsiblePerson,
      toBeDoneBy: this.taskDetail?.toBeDoneBy,
      tmProPriorityId: this.taskDetail?.tmProPriorityId,
      tags: "",
      location: this.taskDetail?.location,
      isEscalate: this.taskDetail?.isEscalate,
      escalationReason: this.taskDetail?.escalationReason,
      remarks: this.taskDetail?.remarks,
    }
    this.changeStatusTask(payload);
  }
  editTask() {
    let formData = {
      department: this.taskDetail.tmProDepartmentId,
      responsiblePersonName: this.taskDetail.responsiblePersonName,
      responsiblePerson: this.taskDetail.responsiblePerson,
      priority: this.taskDetail.tmProPriorityId,
      dueDate: this.getformattedDate(this.getOnlyDate(this.taskDetail.toBeDoneByFormatted)),
      title: this.taskDetail.taskName,
      description: this.taskDetail.description,
      location: this.taskDetail.location,
      //photo: this.taskDetail.photo,
      isEscalate: this.taskDetail.isEscalate,
      escalationReason: this.taskDetail.escalationReason,
      remarks: this.taskDetail.remarks,
    }
    this.cdr.detectChanges();
    this.dialog.open(TaskManagerCreateComponent, {
      width: '860px',
      height: '630px',
      panelClass: ["share-link_container-task", "border-top"],
      data: {
        eventType: "isEdit",
        taskId: this.taskId,
        formData: formData,
        created: this.getOnlyDate(this.taskDetail.created),
        tmProStatusId: this.taskDetail.tmProStatusId
      },
    }).afterClosed().subscribe((res) => {
      if (res.status === 'editSuccess') {
        let ref = this.openSnackBar("Task successfully updated!");
        setTimeout(() => {
          this.getTaskDetailsById(this.taskId);
          this.getTaskImages();
          this.getTaskComments();
        }, 1000); // reload after 2 seconds
      }
    });
  }
  onEdit() {
    // Show buttons only if content differs from original
    this.isEdit = true;
  }
  onCancel() {
    // Reset text and hide buttons
    this.taskDetail.shortDescription = this.originalText;
    this.isEdit = false;
  }
  // onSubmit() {
  //   // Save and hide buttons
  //   this.originalText = this.taskDetail?.shortDescription;
  //   this.isEdit = false;
  //   let payload = {
  //     id: this.taskId,
  //     hotelId: this.tmProHotelId,
  //     tmProStatusId: this.taskDetail.tmProStatusId,
  //     categoryId: 5,
  //     tmProDepartmentId: this.taskDetail?.tmProDepartmentId,
  //     created: this.taskDetail?.created,
  //     closed: this.taskDetail?.closed,
  //     taskOwner: this.taskDetail?.taskOwner,//"61bcc4e5-3f87-4d89-885b-5e49fdeed477",
  //     isInternal: true,
  //     taskName: this.taskDetail?.taskName,
  //     description: this.taskDetail?.description,
  //     shortDescription: this.originalText,
  //     responsiblePerson: this.taskDetail?.responsiblePerson,
  //     toBeDoneBy: this.taskDetail?.toBeDoneBy,
  //     tmProPriorityId: this.taskDetail?.tmProPriorityId,
  //     tags: "",
  //     location: this.taskDetail?.location,
  //     isEscalate: this.taskDetail?.isEscalate
  //   }
  //   this.updateTask(payload);
  //   // Perform save logic here
  // }
  onSubmit(event: any) {
    // Save and hide buttons
    //this.originalText = event;
    this.isEdit = false;
    let payload = {
      id: 0,
      tmProTaskId: this.taskId,
      date: new Date(),
      creator: localStorage.getItem('email'),
      text: this.originalText
    }
    this.saveTask(payload);
    // Perform save logic here
  }
  saveTask(payload: any) {
    this.restfullService.saveTaskComment(payload).subscribe({
      next: async (response) => {
        if (response) {
          this.openSnackBar("Comment Saved Successfully!");
          this.originalText = "";
          this.getTaskDetailsById(this.taskId);
          this.getTaskComments();
        }
      },
      error: (err) => {
        console.error('Error saving comment:', err);
      },
      complete: () => {
      }
    });
  }
  updateTask(payload: any) {
    this.restfullService.updateTaskComment(payload).subscribe({
      next: async (response) => {
        if (response) {
          this.openSnackBar("Comment Saved Successfully!");
          this.originalText = "";
          this.getTaskDetailsById(this.taskId);
          this.getTaskComments();
        }
      },
      error: (err) => {
        console.error('Error saving comment:', err);
      },
      complete: () => {
      }
    });
  }
  changeStatusTask(payload: any) {
    this.globalService.showLoader$.next(true);
    this.restfullService.updateTask(payload).subscribe({
      next: (response: any) => {

        // CASE 1: API returned validation errors
        if (response?.errors && response.errors.length > 0) {
          this.openSnackBarError(response.errors.join(' | '));
          this.globalService.showLoader$.next(false);
          return;
        }

        // CASE 2: success response
        this.openSnackBar("Status Updated!");
        this.originalText = "";

        this.getTaskDetailsById(this.taskId);
        this.getTaskComments();
        this.getTasks();

        this.globalService.showLoader$.next(false);
      },

      error: (err) => {
        this.globalService.showLoader$.next(false);

        // fallback for real HTTP errors
        const message =
          err?.error?.errors?.length
            ? err.error.errors.join(' | ')
            : err?.error?.message || 'Something went wrong';

        this.openSnackBarError(message);

        console.error('Error saving comment:', err);
      }
    });
  }
  // changeStatusTask(payload: any) {
  //   this.globalService.showLoader$.next(true);
  //   this.restfullService.updateTask(payload).subscribe({
  //     next: async (response) => {
  //       if (response) {
  //         this.openSnackBar("Status Updated!");
  //         this.originalText = "";
  //         this.getTaskDetailsById(this.taskId);
  //         this.getTaskComments();
  //         this.getTasks();
  //         this.globalService.showLoader$.next(false);
  //       }
  //     },
  //     error: (err) => {
  //       this.globalService.showLoader$.next(false);
  //       console.error('Error saving comment:', err);
  //     },
  //     complete: () => {
  //       this.globalService.showLoader$.next(false);
  //     }
  //   });
  // }
  onEditComment(comment: any) {
    this.editCommentId = comment.id;
    this.editText = comment.text; // Load current text into textarea
  }
  getTasks() {
    this.restfullService.getTasks(+localStorage.getItem('selectedTmProHotelId')).subscribe((response) => {
      this.globalService.taskManagementCount = response.filter(x => x.tmProStatusId === 1).length;
    })
  }

  onSaveComment() {
    const index = this.taskComments.findIndex(c => c.id === this.editCommentId);
    if (index !== -1) {
      this.taskComments[index].text = this.editText; // Update with edited text
      let payload = {
        id: this.taskComments[index].id,
        tmProTaskId: this.taskId,
        date: new Date(),
        creator: localStorage.getItem('email'),
        text: this.taskComments[index].text
      }
      this.updateTask(payload);
    }
    this.cancelEdit();
  }
  isOverdue(): boolean {
    if (!this.taskDetail.closed) return false;
    const date = new Date(this.taskDetail.closed);
    const today = new Date();
    date.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return date < today && this.taskDetail.statusName !== 'Open';
  }

  onCancelEdit() {
    this.cancelEdit();
  }

  private cancelEdit() {
    this.editCommentId = null;
    this.editText = '';
  }

  onDelete(comment: any) {
    this.taskComments = this.taskComments.filter(c => c.id !== comment.id);
    //Call delete api
    this.restfullService.deleteTaskComments(comment.id).subscribe({
      next: (response) => {
        this.openSnackBar("Note/remarks deleted");
        this.getTaskDetailsById(this.taskId);
        this.getTaskComments();
      },
      error: (err) => {

      }
    })
    if (this.editCommentId === comment.id) {
      this.cancelEdit();
    }
  }

  private openSnackBar(message: string) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      panelClass: ['custom-snackbar'],
      horizontalPosition: 'right',
      verticalPosition: 'top',
      data: {
        svgIcon: 'check-circle',
        message
      }
    });
  }
  private openSnackBarError(message: string) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      panelClass: ['snackbar-error'],
      horizontalPosition: 'right',
      verticalPosition: 'top',
      data: {
        message
      }
    });
  }
  goBack() {
    this.router.navigate(["/pages/tasks"]);
  }
  formatDate(isoString: string): string {
    if (!isoString) return '';
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year}, ${hours}:${minutes}`;
  };
  private setHeaderData() {
    const config: any = {
      showBackButton: true,
      navigationPage: "/pages/tasks",
    };
    this.globalService.isMobile
      ? (config.headerTitle = 'Task ID - ' + this.taskId)
      : (config.info1 = 'Task ID - ' + this.taskId);

    this.globalService.headerData$.next(config);
  }

  getOnlyDate(dateTime: string): string {
    return dateTime.split(',')[0].trim();
  }
  getformattedDate(input) {
    const [day, month, year] = input.split('/');
    return new Date(+year, +month - 1, +day);
  }
}
